/**
 * PATH: packages/email-hub/src/feature/components/email-reader/ReaderBody.tsx
 * FILE_ID: EMAILHUB-EMAILREADER-BODY-001
 * PURPOSE: Preserve commit-then-fill body loading and stacked-thread rendering.
 */
import { RefreshCw } from 'lucide-react'
import EmailThread from '../EmailThread'
import type { EmailReaderController } from './useEmailReaderController'

export function EmailBodySkeleton() {
  return (
    <div data-testid="email-body-skeleton">
      <div className="flex items-center gap-2 mb-4 text-sm text-muted-foreground">
        <RefreshCw className="h-4 w-4 animate-spin text-primary shrink-0" />
        Opening your email…
      </div>
      <div className="animate-pulse">
        <div className="h-3 bg-muted rounded w-11/12 mb-2" />
        <div className="h-3 bg-muted rounded w-9/12 mb-2" />
        <div className="h-3 bg-muted rounded w-10/12 mb-4" />
        <div className="h-32 bg-muted rounded-lg w-full mb-4" />
        <div className="h-3 bg-muted rounded w-8/12 mb-2" />
        <div className="h-3 bg-muted rounded w-6/12" />
      </div>
    </div>
  )
}

export function ReaderBody({
  controller,
}: {
  controller: EmailReaderController
}) {
  const { email, bodyLoading, bodyZoom, combinedBodyRef, find, refetch } =
    controller
  if (!email) return null

  return bodyLoading && !email.body_html ? (
    <EmailBodySkeleton />
  ) : (
    <EmailThread
      key={email.id}
      openedEmail={email}
      onRefetch={refetch}
      zoom={bodyZoom}
      bodyContainerRef={combinedBodyRef}
      className="mb-8"
      findQuery={find.isOpen ? find.bar.query : ''}
    />
  )
}
